import React, { useEffect, useState, useMemo } from "react";
import { Box, Button, Chip, Stack, TextField, Typography } from "@mui/material";
import { GlobalState } from "context/GlobalContext";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import { AuthState } from "context/AuthContext";
import { roleAccess } from "../DiscountMasterList";

function NODPage() {
    const [barcodeFile, setBarcodeFile] = useState("");
    const [barcodeSearchTerm, setBarcodeSearchTerm] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [barcodeData, SetBarcodeData] = useState([]);

    const { user } = AuthState();
    const roleData = roleAccess(user)

    const role = ["VIEWER", "EDITOR"].includes(roleData.roles)

    const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

    // 🔹 Debounce search input
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(barcodeSearchTerm);
        }, 300);

        return () => clearTimeout(handler);
    }, [barcodeSearchTerm]);

    const handleFileChange = (e) => {
        const newFile = e.target.files[0];
        if (!newFile) return;

        const modifiedFile = new File([newFile], newFile.name, {
            type: newFile.type,
        });

        setBarcodeFile(modifiedFile);
    };

    const handleFileUpload = async (e) => {
                e.preventDefault();
                setLoadingOpen(true);
                let form = new FormData();
                if (barcodeFile === "") {
                    // setLoadingOpen(false);
                    setSnackBarOpen(true);
                    setSnackBar({
                        ...snackBar,
                        message: "Please upload some files and try again",
                        severity: "warning",
                        anchorOrigin: { horizontal: "center", vertical: "top" },
                    });
                    setLoadingOpen(false);
                    return;
                }
        
                form.append("files", barcodeFile);
                form.append("email", user.email);
                pythonVmInstance
                    .post("/discount-master/upload-nod-barcodes", form, { headers: { "Content-Type": "multipart/form-data" } })
                    .then((res) => {
                        setLoadingOpen(false);
                        setSnackBarOpen(true);
                        setSnackBar({
                            ...snackBar,
                            message: "Uploaded the files successfully",
                            severity: "success",
                            anchorOrigin: { horizontal: "center", vertical: "top" },
                        });
                        console.log("sldjlisjdfhasdf", res?.data)
                        document.getElementById("fileInput").value = "";
                        setBarcodeFile("")
                        getNODBarcodes()
                    })
                    .catch((err) => {
                        console.log("uploaded", err);
                        const message = err?.response?.data?.message;
                        setLoadingOpen(false);
                        setSnackBarOpen(true);
                        setSnackBar({
                            ...snackBar,
                            message: message ? message : "Unable to uploaded the files",
                            severity: "error",
                            anchorOrigin: { horizontal: "center", vertical: "top" },
                        });
                    });
            };

    const getNODBarcodes = async () => {
        try {
            setLoadingOpen(true);

            const res = await pythonVmInstance({
                url: `/discount-master/nod-barcodes`,
                headers: { "Content-Type": "application/json" },
                method: "GET",
            });

            SetBarcodeData(res?.data || []);
        } catch (error) {
            setSnackBarOpen(true);
            setSnackBar({
                ...snackBar,
                message: "Failed to get NOD barcodes",
                severity: "error",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
        } finally {
            setLoadingOpen(false);
        }
    };

    useEffect(() => {
        getNODBarcodes();
    }, []);

    // 🔹 Memoized filtering (performance optimized)
    const filteredBarcodes = useMemo(() => {
        if (!debouncedSearch) return barcodeData;

        const searchLower = debouncedSearch.toLowerCase();

        return barcodeData.filter((item) =>
            item?.barcode?.toLowerCase().includes(searchLower)
        );
    }, [barcodeData, debouncedSearch]);

    // 🔹 Limit rendered chips to avoid UI freeze
    const visibleBarcodes = useMemo(() => {
        return filteredBarcodes.slice(0, 200);
    }, [filteredBarcodes]);

    return (
        <Stack width="98%" p={2} maxHeight={500}>
            <Typography fontWeight={600} mb={1}>
                Upload NOD Barcodes
            </Typography>

            {/* Upload Section */}
            <Box display="flex" columnGap={2} mb="16px">
                <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    width="40%"
                    sx={{ border: "1px solid lightgray" }}
                    padding="5px"
                    borderRadius="4px"
                >
                    <Button
                        variant="outlined"
                        size="small"
                        component="label"
                        sx={{ height: 28, fontSize: "12px", textTransform: "none" }}
                        disabled={role}
                    >
                        Choose File
                        <input
                            type="file"
                            hidden
                            id = "fileInput"
                            accept=".csv,text/csv"
                            onChange={handleFileChange}
                            disabled={role}
                        />
                    </Button>

                    <Typography variant="caption" width="200px" noWrap>
                        {barcodeFile?.name || "No file chosen"}
                    </Typography>
                </Box>

                <Button variant="contained" disabled={role} onClick={handleFileUpload}>
                    Upload
                </Button>
            </Box>

            {/* Search Section */}
            <Typography fontWeight={600}>
                NOD Barcodes
            </Typography>

            <Box sx={{ mb: 2 }} width="40%">
                <TextField
                    placeholder="Search by Barcode..."
                    fullWidth
                    size="small"
                    value={barcodeSearchTerm}
                    onChange={(e) => setBarcodeSearchTerm(e.target.value)}
                    sx={{
                        background: "#ffffff",
                        "& .MuiOutlinedInput-root": {
                            fontSize: "13px",
                        },
                    }}
                />
            </Box>

            <Typography variant="caption" sx={{ mb: 1 }}>
                Showing {visibleBarcodes.length} of {filteredBarcodes.length}
            </Typography>

            {/* Chips Section */}
            <Stack
                direction="row"
                spacing={1}
                sx={{
                    flexWrap: "wrap",
                    gap: "8px",
                    maxHeight: 300,
                    overflowY: "auto",
                }}
            >
                {visibleBarcodes.map((item, index) => (
                    <Chip
                        key={`${item?.barcode}-${index}`}
                        label={item?.barcode}
                        variant="outlined"
                        size="small"
                    />
                ))}
            </Stack>
        </Stack>
    );
}

export default NODPage;
